import React from 'react'
import PropTypes from 'prop-types'
import DropdownComponent from './DropdownComponent'

const LoginDropdown = (props) => {
  return (
    <li className="navbar-profile nav-item-icon navbar-with-dropdown">
      <a href="javascript:;" className="navbar-link" onClick={props.toggleWithId}>
        {props.linkComponent}
      </a>
      <DropdownComponent
        navList={props.dropDownList}
        id={props.id}
        dropdown={props.dropdown} />
    </li>
  )
}

LoginDropdown.propTypes = {
  id: PropTypes.string,
  toggleWithId: PropTypes.func,
  dropdown: PropTypes.string
}

export default LoginDropdown



// WEBPACK FOOTER //
// ./assets/js/lib/firebase/LoginDropdown.jsx